import './InfoDialog.scss'
import React, { useState, useContext, useMemo } from 'react'
import { TranslationContext } from '../../../../store/translation';
import { useKeepPagePosition } from '../../../../utils/customHooks'
import Dialog, { DialogHead, DialogBody, DialogFooter } from '../../../../components/Dialog';
import reviewDesignImage from '../../../../assets/images/share-link-dialog/review-design.png'
import updateDesignImage from '../../../../assets/images/share-link-dialog/update-design.png'
import contactAboutDesignImage from '../../../../assets/images/share-link-dialog/contact-about-design.png'
import Button from '../../../../components/Button';
import Sprite from '../../../../components/Sprite';

const InfoDialog = ({ onClose, ktoc }) => {
  const { getText } = useContext(TranslationContext);


  useKeepPagePosition()

  const closeDialog = (e) => {
    onClose()
  }

  return (
    <Dialog className={`InfoDialog`} >
      <DialogHead onClose={e => closeDialog(e)}>
        {getText('ui-info-dialog-main-heading')}
      </DialogHead>

      <DialogBody>
        <InfoItem 
          imageSrc={reviewDesignImage}
          title={getText('ui-info-dialog-heading-review')} 
          text={getText('ui-info-dialog-desc-review')} />
        <InfoItem 
          imageSrc={updateDesignImage}
          title={getText('ui-info-dialog-heading-update')} 
          text={getText('ui-info-dialog-desc-update')} />
        <InfoItem 
          imageSrc={contactAboutDesignImage}
          title={getText('ui-info-dialog-heading-contact')} 
          text={getText('ui-info-dialog-desc-contact')} />
      </DialogBody>
      <DialogFooter className="footer-buttons">
        <Button inlineBlock={true} theme={['sm', 'outline', 'center', 'uppercase']} onClick={closeDialog} >{getText('ui-general-ok-long')}</Button>
      </DialogFooter>
    </Dialog>
  )
}

function InfoItem(props) {
  const {
    imageSrc,
    title,
    text,
    className = '',
  } = props

  return (
    <div className={`InfoItem ${className}`}>
      <div className="image-container">
        <Sprite src={imageSrc} />
      </div>
      <div className="content-container">
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </div>
  )
}

export default InfoDialog